export default "__VITE_ASSET__BqVVJiYQ__"